/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {
  Modal,
  Text,
  TouchableHighlight,
  View,
} from 'react-native';
import {styles} from './styles';

interface Props {
  content?: string;
  title?: string;
  exit?: any;
}
const Popup = ({ content, title, exit }: Props) => {
  return (
    <View style={styles.centeredView}>
      <Modal
        animationType="slide"
        transparent={true}
        visible={true}
        onRequestClose={exit}>
        <View style={styles.centeredView}>
          <View style={styles.modalView}>
            <Text style={[styles.modalText, styles.bold]}>{title}</Text>
            <Text style={[styles.modalText]}>{content}</Text>

            <TouchableHighlight
              style={styles.openButton}
              onPress={exit}>
              <Text style={styles.textStyle}>Quitter</Text>
            </TouchableHighlight>
          </View>
        </View>
      </Modal>
    </View>
  );
};

export default Popup;
